/**
 * 	查询会员
 */
export default [
  {
    path: '/searchMember',
    component: () => import(/* webpackChunkName: "Activity" */ '@/views/searchMember/Index.vue'),
    meta: { requiresAuth: true, title: '会员查询', icon: '', role: true },
    children:
      [
        // {
        //     path: '',
        //     component: () => import(/* webpackChunkName: "Activity" */ '@/views/searchMember/SearchMember.vue'),
        //     meta: { title: '查询会员码', role: true },
        // },
        {
          path: '',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/searchMember/Search.vue'),
          meta: { title: '查询会员码', role: true },
        },
        {
          path: 'memberDetail',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/searchMember/MemberDetail.vue'),
          meta: { title: '会员详情', role: true },
        },
        {
          path: 'singleCoupon',
          component: () => import(/* webpackChunkName: "Activity" */ '@/views/searchMember/SingleCoupon.vue'),
          meta: { title: '单个优惠券详情', role: true },
        }
      ]
  }
]
